// components/common/NotFound.js - Clean 404 page
import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center">
      <div className="text-center max-w-md px-4">
        <div className="text-8xl font-bold text-gray-200 mb-4">404</div>
        <h1 className="text-2xl font-bold text-ink mb-2">Page not found</h1>
        <p className="text-mutedink mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex gap-3 justify-center">
          <Link
            to="/"
            className="flex items-center gap-2 px-5 py-2.5 bg-[var(--code-block-bg)] text-white rounded-lg font-medium hover:bg-[var(--code-block-bg)] transition-colors"
          >
            <Home size={16} /> Home
          </Link>
          <Link
            to="/my-courses"
            className="flex items-center gap-2 px-5 py-2.5 bg-surface text-read border rounded-lg font-medium hover:bg-surface-muted transition-colors"
          >
            <Search size={16} /> My Courses
          </Link>
        </div>
      </div>
    </div>
  );
}
